<template>
  <div>
    <div id='team-info' v-if='hasData'>
      <div id='section' v-if='teamInfo.championRecord.length > 0' class='section-html-content'>
        <div class='section-title'>{{ $t('teamInfo.championshipRecord') }}</div>
        <div v-html='teamInfo.championRecord'/>
      </div>

      <div v-if='teamInfo.retiredNumber.length > 0'>
        <div class='section-title'>{{ $t('teamInfo.retiredJersey') }}</div>
        <div class='retiredJersey' v-for="(item, index) in teamInfo.retiredNumber" :key='index'>
          <div>
            {{ item.replace('(', '[').replace(')', ']').replace('(', '（').replace(')', '）') }}
          </div>
          <hr v-if='index != teamInfo.retiredNumber.length - 1'/>
        </div>
      </div>

      <div v-if="configBasicInfo()" id='section' class='section-course-introduction'>
        <div class='section-title'>{{ $t('teamInfo.courseIntroduction') }}</div>
          <div v-if="teamInfo.homeCourt.length > 0"><span>{{ $t("teamInfo.homeCourt") }}</span><span>{{ teamInfo.homeCourt }}</span></div>
          <hr v-if="teamInfo.homeCourt.length > 0"/>
          <div v-if="teamInfo.capacity.length > 0"><span>{{ $t("teamInfo.capacity") }}</span><span>{{ teamInfo.capacity }}</span></div>
          <hr v-if="teamInfo.capacity.length > 0"/>
          <div v-if="teamInfo.openYear.length > 0"><span>{{ $t("teamInfo.openYear") }}</span><span>{{ teamInfo.openYear }}</span></div>
          <hr v-if="teamInfo.openYear.length > 0"/>
          <div v-if="teamInfo.address.length > 0"><span>{{ $t("teamInfo.address") }}</span><span>{{ teamInfo.address }}</span></div>
      </div>

      <div id='section' class='section-html-content' v-if="teamInfo.summary.length > 0">
        <div class='section-title'>{{ $t('teamCoach.profile') }}</div>
        <div v-html='teamInfo.summary'/>
      </div>
    </div>

    <loadStateView :state='hasData ? 0 : (teamInfo === {} ? 1 : 3)'/>
  </div>
</template>

<script>
import { checkEmptyObject } from '@/utils'

export default {
  name: 'team-info',
  data () {
    return {
      teamInfo: {}
    }
  },
  computed: {
    hasData () {
      let info = JSON.parse(JSON.stringify(this.teamInfo))
      delete info.establishTime
      delete info.teamId
      delete info.teamName
      delete info.teamEngName
      delete info.country
      delete info.city
      delete info.establishTime
      delete info.website
      delete info.city
      delete info.playerAge
      delete info.netState

      return !checkEmptyObject(info)
    }
  },
  activated () {
    this.teamInfo = this.$parent.$parent.team
  },
  methods: {
    configBasicInfo: function () {
      if (this.teamInfo.homeCourt.length > 0 || this.teamInfo.capacity.length > 0 || this.teamInfo.openYear.length > 0 || this.teamInfo.address.length > 0) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
@import '~@/styles'

#section
  > div:not(.section-title) // section items
    padding: 15px
    font-size: 14px
    color: #333333

  span:first-child
    color: #999999
    margin-right: 30px
    flex-shrink: 0

.retiredJersey
  font-size: 14px
  color: #333333

  > div
    padding: 0 15px
    line-height: 44px
    height: 44px

.section-course-introduction > div:not(.section-title)
  display: flex
  justify-content: space-between
</style>
